import React, { ReactElement } from 'react';
import { useLocation } from 'react-router';
import { Heading } from 'idsk-react-components';
import ClassType from '../../model/pripomienka/ClassType';
import routes from '../../routing/routes';
import Layout from '../Layout';
import HromadneVyhodnotenieComponent from '../../module/HromadneVyhodnotenie/HromadneVyhodnotenieComponent';
import UserRole from '../../model/currentuser/UserRole';
import SecuredPage from '../../module/SecuredPage';

interface Props {
  classType: ClassType;
}

export default ({ classType }: Props): ReactElement => {
  const { pathname } = useLocation();

  return (
    <Layout
      isHromadna={classType === ClassType.HROMADNA_PRIPOMIENKA}
      breadcrumbRouteList={[{
        heading: classType === ClassType.HROMADNA_PRIPOMIENKA
          ? routes.hromadnePripomienky.hromadneVyhodnotit.name
          : routes.pripomienky.hromadneVyhodnotit.name,
        to: pathname,
      }]}
    >
      <SecuredPage allowForRoles={[UserRole.VYHODNOCOVATEL]}>
        <div>
          <Heading size="l">Hromadné vyhodnotenie pripomienok</Heading>
          <HromadneVyhodnotenieComponent classType={classType} />
        </div>
      </SecuredPage>
    </Layout>
  );
};
